import { functionalUpdate, makeStateUpdater } from '@tanstack/react-table';

import type { OnChangeFn, RowData, TableFeature, Updater } from '@tanstack/react-table';

export type TextEllipsisState = boolean;

export interface TextEllipsisTableState {
  textEllipsis: TextEllipsisState;
}

export interface TextEllipsisOptions {
  onTextEllipsisChange?: OnChangeFn<TextEllipsisState>;
}

export interface TextEllipsisInstance {
  resetTextEllipsis: (defaultState?: TextEllipsisState) => void;
  setTextEllipsis: (updater: Updater<TextEllipsisState>) => void;
}

declare module '@tanstack/react-table' {
  interface TableState extends TextEllipsisTableState {}

  interface InitialTableState extends Partial<TextEllipsisTableState> {}

  interface TableOptionsResolved<TData extends RowData> extends TextEllipsisOptions {}

  interface Table<TData extends RowData> extends TextEllipsisInstance {}
}

export const TableTextEllipsis: TableFeature<unknown> = {
  getInitialState: (state): TextEllipsisTableState => ({ textEllipsis: true, ...state }),

  getDefaultOptions: table => ({
    onTextEllipsisChange: makeStateUpdater('textEllipsis', table),
  }),

  createTable: table => {
    table.setTextEllipsis = updater => {
      const safeUpdater: Updater<TextEllipsisState> = prev => {
        return functionalUpdate(updater, prev);
      };
      return table.options.onTextEllipsisChange?.(safeUpdater);
    };
    table.resetTextEllipsis = defaultState => {
      table.setTextEllipsis(defaultState ?? table.initialState.textEllipsis);
    };
  },
};
